import * as React from 'react';
import { ALL_FILTER_CONFIGS, FilterSection } from './FilterSection';

/**
 * App Directory Filters component.
 *
 * Renders all filter sections using a config-driven approach.
 * Each filter is defined in filterConfigs.ts and rendered by the generic FilterSection component.
 *
 * To add a new filter:
 * 1. Create a new FilterConfig in filterConfigs.ts
 * 2. Add it to allFilterConfigs array
 * 3. Add a new Filters component here and use that in the AppsListPage.tsx
 * 4. Done!
 */

export const RootFilters = () => {
  return <FilterSection config={ALL_FILTER_CONFIGS.root} />;
};

export const CategoryFilters = () => {
  return <FilterSection config={ALL_FILTER_CONFIGS.category} />;
};

export const WorksWithFilter = () => {
  return <FilterSection config={ALL_FILTER_CONFIGS.worksWith} />;
};

export const FeaturesFilter = () => {
  return <FilterSection config={ALL_FILTER_CONFIGS.features} />;
};

export const BuiltByFilter = () => {
  return <FilterSection config={ALL_FILTER_CONFIGS.builtBy} />;
};
